const AssignMID = () => {
  return <>Assign MID</>
}

export default AssignMID;